import React from 'react';
import { CommerceAddress } from '@css-xp/graphtypes/src/generated-types-new';
import { withApollo } from '@css-xp/base';
import { CCPPricing } from '@atlassian/cssxp-typescommon';
import { splitAndCapitalize } from '@css-xp/ppc-utils';
import { getCurrencyByCountry } from './multi-currency-utils';
import './format-commerce-address.scss';

export type CommerceAddressProps = {
  commerceAddress: CommerceAddress | undefined | null;
  showCurrency?: boolean;
  showPricingEligibility?: boolean;
};

const FormatCommerceAddressImpl: React.FC<CommerceAddressProps> = ({
  commerceAddress,
  showCurrency,
  showPricingEligibility,
}) => {
  if (!commerceAddress) {
    return null;
  }
  /*
   Note: All the fields in address are mandatory hence,
   not handling null case except for AddressLine2 and taxId
   */
  return (
    <div className="selected-commerce-address-container" data-testid="selected-commerce-address-container">
      <div className="commerce-address-details">
        <h4 className="commerce-address-details-company-name">{commerceAddress.name || commerceAddress.companyName}</h4>{' '}
        <p>
          {commerceAddress.addressLine1}, {commerceAddress.addressLine2 ? `${commerceAddress?.addressLine2},` : ''}
        </p>
        <p>
          {commerceAddress.city} - {commerceAddress.postcode || commerceAddress.postalCode}
        </p>
        <p>
          {commerceAddress.state}, {commerceAddress.country}
        </p>
        <h5 className="commerce-address-details-header">TAX ID</h5>
        <p className="commerce-address-details-other-address-details">{commerceAddress?.taxId || '-'}</p>
        {showPricingEligibility ? (
          <>
            <h5 className="commerce-address-details-header">Price Eligibility</h5>
            <p className="commerce-address-details-other-address-details">
              {splitAndCapitalize(
                commerceAddress?.priceEligibility || commerceAddress?.shipToPriceEligibility || CCPPricing.COMMERCIAL
              )}
            </p>
          </>
        ) : null}
        {showCurrency && (
          <>
            <h5 className="commerce-address-details-header">Currency</h5>
            <p className="commerce-address-details-other-address-details">
              {getCurrencyByCountry(commerceAddress.country)}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export const FormatCommerceAddress = withApollo(FormatCommerceAddressImpl);
